import store from '@/store'
import { CONDITION_TYPES } from './conditions'
import { TRANSFORMER_TYPES } from './transformers'

class TransformerService {
  apply(target, value, rules, { rawValue } = {}) {
    const transformer = rules || store.getters['TransformersStore/getTransformer'](target)
    const conditionValue = rawValue !== undefined ? rawValue : value

    if (!transformer || !transformer.enabled) {
      return {
        label: value,
        backgroundColor: null,
        textColor: null,
        tooltip: null,
        originalValue: value,
        transformed: false
      }
    }

    const matchingRule = transformer.rules.find(rule => this.evaluateCondition(conditionValue, rule.condition))

    if (!matchingRule) {
      return {
        label: value,
        backgroundColor: null,
        textColor: null,
        tooltip: null,
        originalValue: value,
        transformed: false
      }
    }

    return this.applyTransformers(value, matchingRule.transformers)
  }

  evaluateCondition(value, condition) {
    const conditionType = CONDITION_TYPES[condition.type]
    if (!conditionType) return false
    return conditionType.evaluate(value, condition.config)
  }

  applyTransformers(originalValue, transformers) {
    let result = {
      label: originalValue,
      backgroundColor: null,
      textColor: null,
      tooltip: null,
      originalValue: originalValue,
      transformed: true
    }

    for (const transformer of transformers) {
      const transformerType = TRANSFORMER_TYPES[transformer.type]
      if (transformerType) {
        result = transformerType.apply(result, transformer.config, originalValue)
      }
    }

    return result
  }
}

export default new TransformerService()
